class Navigation {
  constructor() {
    this.navToggle = document.querySelectorAll('.js-nav-toggle');
    this.header = document.querySelector('.site-header ');
    this.dropdownToggle = this.header.querySelectorAll('.js-dropdown-toggle');
  }

  init() {
    this.mobileMenuToggle();
    this.initDropDowns();
  }

  /**
   * Add mobile nav open functionality by adding "open" class to header.
   *
   */
  mobileMenuToggle() {
    this.navToggle.forEach((button) => {
      button.addEventListener('click', (e)=> {
        this.header.classList.toggle('open');
      })
    });
  }

  /**
   * Close all open dropdowns
   *
   */
  closeDropDowns() {
    const dropDownContainers = this.header.querySelectorAll('li.open');
    dropDownContainers.forEach(element => element.classList.remove('open'));
  }

  /**
   * Add click events to all dropdown toggle buttons
   *
   */
  initDropDowns() {
    this.dropdownToggle.forEach(toggle => {
      const dropDownElement = toggle.closest('li');

      if(dropDownElement){
        toggle.addEventListener('click', e => {
          const openToggle = !dropDownElement.classList.contains('open');

          this.closeDropDowns();

          dropDownElement.classList.toggle('open', openToggle);
        });
      }
    });

    //close dropdown when clicking outside dropdown.
    document.addEventListener('click', () => this.closeDropDowns());
  }

}

export default new Navigation();
